jQuery(document).ready(function($) {
	const base = "growl-component-navbar";
	const toggle_menu = function() {
		$(`.${base}__menu-wrapper`).toggleClass(`${base}__menu-wrapper--active`);
	} 
	$(`.${base}__burger`).click(toggle_menu);
	$(`.${base}__menu-disabler`).click(toggle_menu);
});